module.exports = __webpack_public_path__ + "img/content4-7.70beacf6.png";